import { render, staticRenderFns } from "./DimensionItem.vue?vue&type=template&id=775e0b4f&scoped=true"
import script from "./DimensionItem.vue?vue&type=script&lang=js"
export * from "./DimensionItem.vue?vue&type=script&lang=js"
import style0 from "./DimensionItem.vue?vue&type=style&index=0&id=775e0b4f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775e0b4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775e0b4f')) {
      api.createRecord('775e0b4f', component.options)
    } else {
      api.reload('775e0b4f', component.options)
    }
    module.hot.accept("./DimensionItem.vue?vue&type=template&id=775e0b4f&scoped=true", function () {
      api.rerender('775e0b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/dragItem/DimensionItem.vue"
export default component.exports